import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
  integrations: [
    // No browserTracingIntegration or replayIntegration as per user's request
  ],
  
  // Disable tracing by setting tracesSampleRate to 0
  tracesSampleRate: 0,
  
  // We're only enabling basic error tracking, not performance monitoring
  // Further customize the configuration as needed
  
  // This sets the environment to match your Laravel configuration
  environment: import.meta.env.VITE_APP_ENV || "production",
});

export default Sentry; 